// extracted by mini-css-extract-plugin
export default {"header":"ProducersTable_header__vk2cR"};